import { render } from "./ProviderObject.vue?vue&type=template&id=277ad1ab"
import script from "./ProviderObject.vue?vue&type=script&lang=js"
export * from "./ProviderObject.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__